import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { WithLocation } from './containers/WithLocation';

// LOGIN COMPONENTS:
import ToolboxOauthTest from './logins/ToolboxOauthTest';
import gvpprod from './logins/gvpprod';
import mpa from './logins/mpa';
import algar from './logins/algar';
import alp from './logins/alp';
import alp2 from './logins/alp2';
import amigo from './logins/amigo';
import anet from './logins/anet';
import ant from './logins/ant';
import claroVideo from './logins/clarovideo';
import etb from './logins/etb';
import hvtv from './logins/hvtv';
import playHub from './logins/playHub';
import watch from './logins/watch';
import vero from './logins/vero'
import sup from './logins/sup'
import ctc from './logins/ctc'
import startv from './logins/startv'
import bahiavision from './logins/bahiavision'
import cbv from './logins/cbv'
import tot from './logins/tot'
import elcuatro from './logins/elcuatro'
import dibox from './logins/dibox'
import ent from './logins/ent'
import emc from './logins/emc'
import axs from './logins/axs'
import uplay from './logins/uplay'
import tcm from './logins/tcm'
import cotas from './logins/cotas'
import gig from './logins/gig'
import sumi from './logins/sumi'
import skymx from './logins/skymx'
import online from './logins/online'
import comt from './logins/comt'
import vox from './logins/vox'
import zap from './logins/zap'
import cablecolor from './logins/cablecolor'
import netfoz from './logins/netfoz'
import itop from './logins/itop'
import cabletel from './logins/cabletel'
import cabonet from './logins/cabonet'
import supercabo from './logins/supercabo'
import cdi from './logins/cdi'
import ggnet from './logins/ggnet'
import gnet from './logins/gnet'
import netlife from './logins/netlife'
import ice from './logins/ice'
import infa from './logins/infa'
import maranet from './logins/maranet'
import maxitv from './logins/maxitv'
import multiplic from './logins/multiplic'
import oopstv from './logins/oopstv'
import clig from './logins/clig'
import cmnet from './logins/cmnet'
import conectcor from './logins/conectcor'
import mts from './logins/mts'
import entel from './logins/entel'
import cdv from './logins/cdv'
import cnp from './logins/cnp'
import mrc from './logins/mrc'
import plena from './logins/plena'
import tlc_uy from './logins/tlc_uy'
import telesp from './logins/telesp'
import expressar from './logins/expressar'
import cnl from './logins/cnl'
import desktop from './logins/desktop'
import digital from './logins/digital'
import fibra from './logins/fibra'
import five from './logins/five'
import innovanet from './logins/innovanet'
import myj from './logins/myj'
import netcom from './logins/netcom'
import niufibra from './logins/niufibra'
import ntc from './logins/ntc'
import nxp from './logins/nxp'
import oxenete from './logins/oxenete'
import rox from './logins/rox'
import superimagem from './logins/superimagem'
import tely from './logins/tely'
import upvc from './logins/upvc'
import hdfibra from './logins/hdfibra'
import ligue from './logins/ligue'
import entbo from './logins/entbo'
import sattvgo from './logins/sattvgo'
import personal from './logins/personal'
import campsoft from './logins/campsoft';
import bonda from './logins/bonda';
import yekkoclub from './logins/yekkoclub';
import multilaser from './logins/multilaser';
import puntonet from './logins/puntonet';
import onix5 from './logins/onix5';
import reelunet from './logins/reelunet';
import uslink from './logins/uslink';
import wow from './logins/wow';
import nettplus from './logins/nettplus';
import etapa from './logins/etapa';
import vivabo from './logins/vivabo';
import cnt from './logins/cnt';
import ccc from './logins/ccc'
import gtd from './logins/gtd';
import pcafp from './logins/pcafp';
import redpower from './logins/redpower';
import mifibra from './logins/mifibra';
import tpp from './logins/tpp';
import cableyvideo from './logins/cableyvideo';
import tucuman from './logins/tucuman';
import interfy from './logins/interfy';
import gpon from './logins/gpon';
import alcans from './logins/alcans';
import reduno from './logins/reduno';
import nubenet from './logins/nubenet';
import scpl from './logins/scpl';
import ispcube from './logins/ispcube';
import netiz from './logins/netiz';
import cplus from './logins/cplus';
import wowpe from './logins/wowpe';
import projectone from './logins/projectone';
import americabr from './logins/americabr';
import silicomlan from './logins/silicomlan';
import audibel from './logins/audibel';
import sista from './logins/sista';
import eastnet from './logins/eastnet';
import net2home from './logins/net2home';
import itic from './logins/itic';
import srguido from './logins/srguido';
import sectornet from './logins/sectornet';
import airfibra from './logins/airfibra';
import netlink from './logins/netlink';
import maxfibra from './logins/maxfibra';
import ingecom from './logins/ingecom';
import redespradal from './logins/redespradal';
import airnet from './logins/airnet';
import curuzu from './logins/curuzu';
import netsul from './logins/netsul';
import jbtecnologia from './logins/jbtecnologia';
import fusionip from './logins/fusionip';
import winter from './logins/winter';
import vhg from './logins/vhg';
import cpar from './logins/cpar';
import conexionsur from './logins/conexionsur';
import rznet from './logins/rznet';
import cepral from './logins/cepral';
import internetrural from './logins/internetrural';
import fenet from './logins/fenet';
import tecnowifi from './logins/tecnowifi';
import mach from './logins/mach';
import cobweb from './logins/cobweb';
import linknet from './logins/linknet';
import cyberia from './logins/cyberia';
import maisinternet from './logins/maisinternet';
import thundernet from './logins/thundernet';
import ssservicios from './logins/ssservicios';
import gigalink from './logins/gigalink';
import next from './logins/next';
import virtex from './logins/virtex';
import cableplay from './logins/cableplay';
import argentum from './logins/argentum';
import cableatierra from './logins/cableatierra';
import guabi from './logins/guabi';
import sis from './logins/sis';
import iqnet from './logins/iqnet';
import sisintegradores from './logins/sisintegradores';
import weconnect from './logins/weconnect';
import solcomunicacion from './logins/solcomunicacion';
import interede from './logins/interede';
import stationet from './logins/stationet';
import dedicado from './logins/dedicado';
import gapfiber from './logins/gapfiber';
import servicable from './logins/servicable';
import powernet from './logins/powernet';
import blutelco from './logins/blutelco';
import research from './logins/research';
import wendor from './logins/wendor';
import wisphub from './logins/wisphub';
import montevideoportal from './logins/montevideoportal';
import we from './logins/we';
import lemmoninternet from './logins/lemmoninternet';
import intelcom from './logins/intelcom';
import cst from './logins/cst';
import linage from './logins/linage';
import fibramas from './logins/fibramas';
import g1 from './logins/g1';
import guajiranet from './logins/guajiranet';
import radiusnet from './logins/radiusnet';
import linksat from './logins/linksat';
import ultra from './logins/ultra';
import velonet from './logins/velonet';
import oiti from './logins/oiti';
import spacom from './logins/spacom';
import conexiontic from './logins/conexiontic';
import fibravalle from './logins/fibravalle';
import weplus from './logins/weplus';
import cirtel from './logins/cirtel';
import arrobasoluciones from './logins/arrobasoluciones';
import ccom from './logins/ccom';
import control from './logins/control';
import onemultiplay from './logins/onemultiplay';
import servired from './logins/servired';
import proyecto from './logins/proyecto';
import directibu from './logins/directibu';
import zaaz from './logins/zaaz';
import netcomunicaciones from './logins/netcomunicaciones';
import fastnet from './logins/fastnet';
import windnet from './logins/windnet';
import infinity from './logins/infinity';
import conecta from './logins/conecta';
import medialink from './logins/medialink';
import conectafoot from './logins/conectafoot';
import coteflan from './logins/coteflan';
import superplayer from './logins/superplayer';
import verla from './logins/verla';
import nipbr from './logins/nipbr';
import betel from './logins/betel';
import conectv from './logins/conectv';
import trex from './logins/trex';
import zaazpe from './logins/zaazpe';
import sinergy from './logins/sinergy';
import speednetbr from './logins/speednetbr';
import conectagold from './logins/conectagold';
import flix from './logins/flix';
import tecnosul from './logins/tecnosul';
import jmg from './logins/jmg';
import netwest from './logins/netwest';
import albaposse from './logins/albaposse';
import velonetar from './logins/velonetar'
import colombianet from './logins/colombianet';
import nwccauca from './logins/nwccauca';
import speedy from './logins/speedy';
import fibercom from './logins/fibercom';
import vallevision from './logins/vallevision';
import proxxima from './logins/proxxima';
import capinzalnet from './logins/capinzalnet';
import tlginternet from './logins/tlginternet';
import galgo from './logins/galgo';
import alva from './logins/alva';
import legon from './logins/legon';
import verobr from './logins/verobr';
import telcosur from './logins/telcosur';
import redhogar from './logins/redhogar';
import imagineintegrators from './logins/imagineintegrators';
import ifx from './logins/ifx';
import ecowireless from './logins/ecowireless';
import nubenetar from './logins/nubenetar';
import etelcom from './logins/etelcom';
import jjnet from './logins/jjnet';
import ecuanet from './logins/ecuanet';
import ameport from './logins/ameport';
import coltel from './logins/coltel';
import netline from './logins/netline';
import mundopacifico from './logins/mundopacifico';
import naonda from './logins/naonda';
import fibranet from './logins/fibranet';

const routes = (
  <Routes>
    <Route path="/toolboxoauthtest" Component={WithLocation(ToolboxOauthTest)} />
    <Route path="/gvpprod" Component={WithLocation(gvpprod)} />
    <Route path="/mpa" Component={WithLocation(mpa)} />
    <Route path="/algar" Component={WithLocation(algar)} />
    <Route path="/alp" Component={WithLocation(alp)} />
    <Route path="/alp2" Component={WithLocation(alp2)} />
    <Route path="/amigo" Component={WithLocation(amigo)} />
    <Route path="/anet" Component={WithLocation(anet)} />
    <Route path="/ant" Component={WithLocation(ant)} />
    <Route path="/clarovideo" Component={WithLocation(claroVideo)} />
    <Route path="/etb" Component={WithLocation(etb)} />
    <Route path="/hvtv" Component={WithLocation(hvtv)} />
    <Route path="/playhub" Component={WithLocation(playHub)} />
    <Route path="/watch" Component={WithLocation(watch)} />
    <Route path="/vero" Component={WithLocation(vero)} />
    <Route path="/sup" Component={WithLocation(sup)} />
    <Route path="/ctc" Component={WithLocation(ctc)} />
    <Route path="/startv" Component={WithLocation(startv)} />
    <Route path="/bahiavision" Component={WithLocation(bahiavision)} />
    <Route path="/cbv" Component={WithLocation(cbv)} />
    <Route path="/tot" Component={WithLocation(tot)} />
    <Route path="/elcuatro" Component={WithLocation(elcuatro)} />
    <Route path="/dibox" Component={WithLocation(dibox)} />
    <Route path="/ent" Component={WithLocation(ent)} />
    <Route path="/emc" Component={WithLocation(emc)} />
    <Route path="/axs" Component={WithLocation(axs)} />
    <Route path="/uplay" Component={WithLocation(uplay)} />
    <Route path="/tcm" Component={WithLocation(tcm)} />
    <Route path="/gig" Component={WithLocation(gig)} />
    <Route path="/cotas" Component={WithLocation(cotas)} />
    <Route path="/sumi" Component={WithLocation(sumi)} />
    <Route path="/skymx" Component={WithLocation(skymx)} />
    <Route path="/online" Component={WithLocation(online)} />
    <Route path="/comt" Component={WithLocation(comt)} />
    <Route path="/vox" Component={WithLocation(vox)} />
    <Route path="/zap" Component={WithLocation(zap)} />
    <Route path="/cablecolor" Component={WithLocation(cablecolor)} />
    <Route path="/netfoz" Component={WithLocation(netfoz)} />
    <Route path="/itop" Component={WithLocation(itop)} />
    <Route path="/cabletel" Component={WithLocation(cabletel)} />
    <Route path="/cabonet" Component={WithLocation(cabonet)} />
    <Route path="/supercabo" Component={WithLocation(supercabo)} />
    <Route path="/cdi" Component={WithLocation(cdi)} />
    <Route path="/ggnet" Component={WithLocation(ggnet)} />
    <Route path="/gnet" Component={WithLocation(gnet)} />
    <Route path="/netlife" Component={WithLocation(netlife)} />
    <Route path="/ice" Component={WithLocation(ice)} />
    <Route path="/infa" Component={WithLocation(infa)} />
    <Route path="/maranet" Component={WithLocation(maranet)} />
    <Route path="/maxitv" Component={WithLocation(maxitv)} />
    <Route path="/multiplic" Component={WithLocation(multiplic)} />
    <Route path="/oopstv" Component={WithLocation(oopstv)} />
    <Route path="/clig" Component={WithLocation(clig)} />
    <Route path="/cmnet" Component={WithLocation(cmnet)} />
    <Route path="/conectcor" Component={WithLocation(conectcor)} />
    <Route path="/mts" Component={WithLocation(mts)} />
    <Route path="/entel" Component={WithLocation(entel)} />
    <Route path="/cdv" Component={WithLocation(cdv)} />
    <Route path="/cnp" Component={WithLocation(cnp)} />
    <Route path="/mrc" Component={WithLocation(mrc)} />
    <Route path="/plena" Component={WithLocation(plena)} />
    <Route path="/tlc_uy" Component={WithLocation(tlc_uy)} />
    <Route path="/telesp" Component={WithLocation(telesp)} />
    <Route path="/expressar" Component={WithLocation(expressar)} />
    <Route path="/cnl" Component={WithLocation(cnl)} />
    <Route path="/desktop" Component={WithLocation(desktop)} />
    <Route path="/digital" Component={WithLocation(digital)} />
    <Route path="/fibra" Component={WithLocation(fibra)} />
    <Route path="/five" Component={WithLocation(five)} />
    <Route path="/innovanet" Component={WithLocation(innovanet)} />
    <Route path="/myj" Component={WithLocation(myj)} />
    <Route path="/netcom" Component={WithLocation(netcom)} />
    <Route path="/niufibra" Component={WithLocation(niufibra)} />
    <Route path="/ntc" Component={WithLocation(ntc)} />
    <Route path="/nxp" Component={WithLocation(nxp)} />
    <Route path="/oxenete" Component={WithLocation(oxenete)} />
    <Route path="/rox" Component={WithLocation(rox)} />
    <Route path="/superimagem" Component={WithLocation(superimagem)} />
    <Route path="/tely" Component={WithLocation(tely)} />
    <Route path="/upvc" Component={WithLocation(upvc)} />
    <Route path="/hdfibra" Component={WithLocation(hdfibra)} />
    <Route path="/ligue" Component={WithLocation(ligue)} />
    <Route path="/entbo" Component={WithLocation(entbo)} />
    <Route path="/sattvgo" Component={WithLocation(sattvgo)} />
    <Route path="/per_py" Component={WithLocation(personal)} />
    <Route path="/campsoft" Component={WithLocation(campsoft)} />
    <Route path="/bonda" Component={WithLocation(bonda)} />
    <Route path="/yekkoclub" Component={WithLocation(yekkoclub)} />
    <Route path="/multilaser" Component={WithLocation(multilaser)} />
    <Route path="/puntonet" Component={WithLocation(puntonet)} />
    <Route path="/onix5" Component={WithLocation(onix5)} />
    <Route path="/reelunet" Component={WithLocation(reelunet)} />
    <Route path="/uslink" Component={WithLocation(uslink)} />
    <Route path="/wow" Component={WithLocation(wow)} />
    <Route path="/nettplus" Component={WithLocation(nettplus)} />
    <Route path="/etapa" Component={WithLocation(etapa)} />
    <Route path="/vivabo" Component={WithLocation(vivabo)} />
    <Route path="/cnt" Component={WithLocation(cnt)} />
    <Route path="/ccc" Component={WithLocation(ccc)} />
    <Route path="/gtd" Component={WithLocation(gtd)} />
    <Route path="/pcafp" Component={WithLocation(pcafp)} />
    <Route path="/redpower" Component={WithLocation(redpower)} />
    <Route path="/mifibra" Component={WithLocation(mifibra)} />
    <Route path="/tpp" Component={WithLocation(tpp)} />
    <Route path="/cableyvideo" Component={WithLocation(cableyvideo)} />
    <Route path="/tucuman" Component={WithLocation(tucuman)} />
    <Route path="/interfy" Component={WithLocation(interfy)} />
    <Route path="/gpon" Component={WithLocation(gpon)} />
    <Route path="/alcans" Component={WithLocation(alcans)} />
    <Route path="/reduno" Component={WithLocation(reduno)} />
    <Route path="/nubenet" Component={WithLocation(nubenet)} />
    <Route path="/scpl" Component={WithLocation(scpl)} />
    <Route path="/ispcube" Component={WithLocation(ispcube)} />
    <Route path="/netiz" Component={WithLocation(netiz)} />
    <Route path="/cplus" Component={WithLocation(cplus)} />
    <Route path="/wowpe" Component={WithLocation(wowpe)} />
    <Route path="/projectone" Component={WithLocation(projectone)} />
    <Route path="/americabr" Component={WithLocation(americabr)} />
    <Route path="/silicomlan" Component={WithLocation(silicomlan)} />
    <Route path="/audibel" Component={WithLocation(audibel)} />
    <Route path="/sista" Component={WithLocation(sista)} />
    <Route path="/eastnet" Component={WithLocation(eastnet)} />
    <Route path="/net2home" Component={WithLocation(net2home)} />
    <Route path="/itic" Component={WithLocation(itic)} />
    <Route path="/srguido" Component={WithLocation(srguido)} />
    <Route path="/sectornet" Component={WithLocation(sectornet)} />
    <Route path="/airfibra" Component={WithLocation(airfibra)} />
    <Route path="/netlink" Component={WithLocation(netlink)} />
    <Route path="/maxfibra" Component={WithLocation(maxfibra)} />
    <Route path="/ingecom" Component={WithLocation(ingecom)} />
    <Route path="/redespradal" Component={WithLocation(redespradal)} />
    <Route path="/airnet" Component={WithLocation(airnet)} />
    <Route path="/curuzu" Component={WithLocation(curuzu)} />
    <Route path="/netsul" Component={WithLocation(netsul)} />
    <Route path="/jbtecnologia" Component={WithLocation(jbtecnologia)} />
    <Route path="/fusionip" Component={WithLocation(fusionip)} />
    <Route path="/winter" Component={WithLocation(winter)} />
    <Route path="/vhg" Component={WithLocation(vhg)} />
    <Route path="/cpar" Component={WithLocation(cpar)} />
    <Route path="/conexionsur" Component={WithLocation(conexionsur)} />
    <Route path="/rznet" Component={WithLocation(rznet)} />
    <Route path="/cepral" Component={WithLocation(cepral)} />
    <Route path="/internetrural" Component={WithLocation(internetrural)} />
    <Route path="/fenet" Component={WithLocation(fenet)} />
    <Route path="/tecnowifi" Component={WithLocation(tecnowifi)} />
    <Route path="/mach" Component={WithLocation(mach)} />
    <Route path="/cobweb" Component={WithLocation(cobweb)} />
    <Route path="/linknet" Component={WithLocation(linknet)} />
    <Route path="/cyberia" Component={WithLocation(cyberia)} />
    <Route path="/maisinternet" Component={WithLocation(maisinternet)} />
    <Route path="/thundernet" Component={WithLocation(thundernet)} />
    <Route path="/ssservicios" Component={WithLocation(ssservicios)} />
    <Route path="/gigalink" Component={WithLocation(gigalink)} />
    <Route path="/next" Component={WithLocation(next)} />
    <Route path="/virtex" Component={WithLocation(virtex)} />
    <Route path="/cableplay" Component={WithLocation(cableplay)} />
    <Route path="/argentum" Component={WithLocation(argentum)} />
    <Route path="/cableatierra" Component={WithLocation(cableatierra)} />
    <Route path="/guabi" Component={WithLocation(guabi)} />
    <Route path="/sis" Component={WithLocation(sis)} />
    <Route path="/iqnet" Component={WithLocation(iqnet)} />
    <Route path="/sisintegradores" Component={WithLocation(sisintegradores)} />
    <Route path="/weconnect" Component={WithLocation(weconnect)} />
    <Route path="/solcomunicacion" Component={WithLocation(solcomunicacion)} />
    <Route path="/interede" Component={WithLocation(interede)} />
    <Route path="/stationet" Component={WithLocation(stationet)} />
    <Route path="/dedicado" Component={WithLocation(dedicado)} />
    <Route path="/gapfiber" Component={WithLocation(gapfiber)} />
    <Route path="/servicable" Component={WithLocation(servicable)} />
    <Route path="/powernet" Component={WithLocation(powernet)} />
    <Route path="/blutelco" Component={WithLocation(blutelco)} />
    <Route exact path="/research" Component={WithLocation(research)} />
    <Route exact path="/wendor" Component={WithLocation(wendor)} />
    <Route exact path="/wisphub" Component={WithLocation(wisphub)} />
    <Route exact path="/montevideoportal" Component={WithLocation(montevideoportal)} />
    <Route exact path="/we" Component={WithLocation(we)} />
    <Route exact path="/lemmoninternet" Component={WithLocation(lemmoninternet)} />
    <Route exact path="/intelcom" Component={WithLocation(intelcom)} />
    <Route exact path="/cst" Component={WithLocation(cst)} />
    <Route exact path="/linage" Component={WithLocation(linage)} />
    <Route exact path="/fibramas" Component={WithLocation(fibramas)} />
    <Route exact path="/g1" Component={WithLocation(g1)} />
    <Route exact path="/guajiranet" Component={WithLocation(guajiranet)} />
    <Route exact path="/radiusnet" Component={WithLocation(radiusnet)} />
    <Route exact path="/linksat" Component={WithLocation(linksat)} />
    <Route exact path="/ultra" Component={WithLocation(ultra)} />
    <Route exact path="/velonet" Component={WithLocation(velonet)} />
    <Route exact path="/oiti" Component={WithLocation(oiti)} />
    <Route exact path="/spacom" Component={WithLocation(spacom)} />
    <Route exact path="/conexiontic" Component={WithLocation(conexiontic)} />
    <Route exact path="/fibravalle" Component={WithLocation(fibravalle)} />
    <Route exact path="/weplus" Component={WithLocation(weplus)} />
    <Route exact path="/cirtel" Component={WithLocation(cirtel)} />
    <Route exact path="/arrobasoluciones" Component={WithLocation(arrobasoluciones)} />
    <Route exact path="/ccom" Component={WithLocation(ccom)} />
    <Route exact path="/control" Component={WithLocation(control)} />
    <Route exact path="/onemultiplay" Component={WithLocation(onemultiplay)} />
    <Route exact path="/servired" Component={WithLocation(servired)} />
    <Route exact path="/proyecto" Component={WithLocation(proyecto)} />
    <Route exact path="/directibu" Component={WithLocation(directibu)} />
    <Route exact path="/zaaz" Component={WithLocation(zaaz)} />
    <Route exact path="/netcomunicaciones" Component={WithLocation(netcomunicaciones)} />
    <Route exact path="/fastnet" Component={WithLocation(fastnet)} />
    <Route exact path="/windnet" Component={WithLocation(windnet)} />
    <Route exact path="/infinity" Component={WithLocation(infinity)} />
    <Route exact path="/conecta" Component={WithLocation(conecta)} />
    <Route exact path="/medialink" Component={WithLocation(medialink)} />
    <Route exact path="/conectafoot" Component={WithLocation(conectafoot)} />
    <Route exact path="/coteflan" Component={WithLocation(coteflan)} />
    <Route exact path="/superplayer" Component={WithLocation(superplayer)} />
    <Route exact path="/verla" Component={WithLocation(verla)} />
    <Route exact path="/nipbr" Component={WithLocation(nipbr)} />
    <Route exact path="/betel" Component={WithLocation(betel)} />
    <Route exact path="/conectv" Component={WithLocation(conectv)} />
    <Route exact path="/trex" Component={WithLocation(trex)} />
    <Route exact path="/zaazpe" Component={WithLocation(zaazpe)} />
    <Route exact path="/sinergy" Component={WithLocation(sinergy)} />
    <Route exact path="/speednetbr" Component={WithLocation(speednetbr)} />
    <Route exact path="/conectagold" Component={WithLocation(conectagold)} />
    <Route exact path="/flix" Component={WithLocation(flix)} />
    <Route exact path="/tecnosul" Component={WithLocation(tecnosul)} />
    <Route exact path="/jmg" Component={WithLocation(jmg)} />
    <Route exact path="/netwest" Component={WithLocation(netwest)} />
    <Route exact path="/albaposse" Component={WithLocation(albaposse)} />
    <Route exact path="/velonetar" Component={WithLocation(velonetar)} />
    <Route exact path="/colombianet" Component={WithLocation(colombianet)} />
    <Route exact path="/nwccauca" Component={WithLocation(nwccauca)} />
    <Route exact path="/speedy" Component={WithLocation(speedy)} />
    <Route exact path="/fibercom" Component={WithLocation(fibercom)} />
    <Route exact path="/vallevision" Component={WithLocation(vallevision)} />
    <Route exact path="/proxxima" Component={WithLocation(proxxima)} />
    <Route exact path="/capinzalnet" Component={WithLocation(capinzalnet)} />
    <Route exact path="/tlginternet" Component={WithLocation(tlginternet)} />
    <Route exact path="/galgo" Component={WithLocation(galgo)} />
    <Route exact path="/alva" Component={WithLocation(alva)} />
    <Route exact path="/legon" Component={WithLocation(legon)} />
    <Route exact path="/verobr" Component={WithLocation(verobr)} />
    <Route exact path="/telcosur" Component={WithLocation(telcosur)} />
    <Route exact path="/redhogar" Component={WithLocation(redhogar)} />
    <Route exact path="/imagineintegrators" Component={WithLocation(imagineintegrators)} />
    <Route exact path="/ifx" Component={WithLocation(ifx)} />
    <Route exact path="/ecowireless" Component={WithLocation(ecowireless)} />
    <Route exact path="/nubenetar" Component={WithLocation(nubenetar)} />
    <Route exact path="/etelcom" Component={WithLocation(etelcom)} />
    <Route exact path="/jjnet" Component={WithLocation(jjnet)} />
    <Route exact path="/ecuanet" Component={WithLocation(ecuanet)} />
    <Route exact path="/ameport" Component={WithLocation(ameport)} />
    <Route exact path="/coltel" Component={WithLocation(coltel)} />
    <Route exact path="/netline" Component={WithLocation(netline)} />
    <Route exact path="/mundopacifico" Component={WithLocation(mundopacifico)} />
    <Route exact path="/naonda" Component={WithLocation(naonda)} />
    <Route exact path="/fibranet" Component={WithLocation(fibranet)} />

  </Routes>
);

export default routes;
